import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import InputCurrency from 'components/InputCurrency'
import { Controller, useFormContext, useFieldArray } from 'react-hook-form'

type ActivityFormProps = {
  inputProps: (fieldName: keyof ActivityApiRequest) => {
    InputLabelProps: {
      shrink: boolean
    }
  }
}

export const TransportScheduleForm = ({ inputProps }: ActivityFormProps) => {
  const { register, control, formState } = useFormContext<ActivityApiRequest>()
  const { fields } = useFieldArray({
    control,
    name: 'activitiesTransports',
  })

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">Transportes</Typography>
      </Box>

      {fields.map((field, index) => (
        <Card key={field.id} sx={{ mb: 2 }}>
          <CardContent>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="subtitle1">
                Transporte {index + 1}
              </Typography>
            </Box>

            <Grid container spacing={3} rowSpacing={2}>
              <Grid item xs={4}>
                <TextField
                  error={
                    !!formState?.errors?.activitiesTransports?.[index]
                      ?.departure_at?.message
                  }
                  helperText={
                    formState?.errors?.activitiesTransports?.[index]
                      ?.departure_at?.message
                  }
                  fullWidth
                  label="Saída às (hs)"
                  InputLabelProps={{ shrink: true }}
                  placeholder=""
                  margin="normal"
                  type="time"
                  variant="outlined"
                  {...register(`activitiesTransports.${index}.departure_at`)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  error={
                    !!formState?.errors?.activitiesTransports?.[index]
                      ?.shipping_company?.message
                  }
                  helperText={
                    formState?.errors?.activitiesTransports?.[index]
                      ?.shipping_company?.message
                  }
                  fullWidth
                  label="Transportadora"
                  margin="normal"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  {...register(
                    `activitiesTransports.${index}.shipping_company`,
                  )}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  error={
                    !!formState?.errors?.activitiesTransports?.[index]
                      ?.type_shipping_company?.message
                  }
                  helperText={
                    formState?.errors?.activitiesTransports?.[index]
                      ?.type_shipping_company?.message
                  }
                  fullWidth
                  label="Tipo Transporte"
                  margin="normal"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  {...register(
                    `activitiesTransports.${index}.type_shipping_company`,
                  )}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  error={
                    !!formState?.errors?.activitiesTransports?.[index]
                      ?.return_at?.message
                  }
                  helperText={
                    formState?.errors?.activitiesTransports?.[index]?.return_at
                      ?.message
                  }
                  fullWidth
                  label="Retorno às (hs)"
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  type="time"
                  variant="outlined"
                  {...register(`activitiesTransports.${index}.return_at`)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  error={
                    !!formState?.errors?.activitiesTransports?.[index]
                      ?.driver_name?.message
                  }
                  helperText={
                    formState?.errors?.activitiesTransports?.[index]
                      ?.driver_name?.message
                  }
                  fullWidth
                  label="Nome Motorista"
                  margin="normal"
                  type="text"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  {...register(`activitiesTransports.${index}.driver_name`)}
                />
              </Grid>

              <Grid item xs={4}>
                <Controller
                  name={`activitiesTransports.${index}.value_shipping_company`}
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <InputCurrency
                        error={
                          !!formState?.errors?.activitiesTransports?.[index]
                            ?.value_shipping_company?.message
                        }
                        helperText={
                          formState?.errors?.activitiesTransports?.[index]
                            ?.value_shipping_company?.message
                        }
                        fullWidth
                        label="Valor Transporte"
                        id={`value_shipping_company_${index}`}
                        onChange={onChange}
                        value={value}
                      />
                    )
                  }}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Restaurante"
                  type="text"
                  margin="normal"
                  variant="outlined"
                  error={
                    !!formState?.errors?.activitiesTransports?.[index]
                      ?.restaurant?.message
                  }
                  helperText={
                    formState?.errors?.activitiesTransports?.[index]?.restaurant
                      ?.message
                  }
                  InputLabelProps={{ shrink: true }}
                  {...register(`activitiesTransports.${index}.restaurant`)}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Pacote Restaurante"
                  type="text"
                  margin="normal"
                  variant="outlined"
                  error={
                    !!formState?.errors?.activitiesTransports?.[index]
                      ?.restaurant_package?.message
                  }
                  helperText={
                    formState?.errors?.activitiesTransports?.[index]
                      ?.restaurant_package?.message
                  }
                  InputLabelProps={{ shrink: true }}
                  {...register(
                    `activitiesTransports.${index}.restaurant_package`,
                  )}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Previsão de Chegada na Unidade"
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  type="time"
                  variant="outlined"
                  sx={{
                    svg: {
                      color: formState?.errors?.activitiesTransports?.[index]
                        ?.arrival_forecast_last_unit?.message
                        ? 'red'
                        : undefined,
                    },
                  }}
                  error={
                    !!formState?.errors?.activitiesTransports?.[index]
                      ?.arrival_forecast_last_unit?.message
                  }
                  helperText={
                    formState?.errors?.activitiesTransports?.[index]
                      ?.arrival_forecast_last_unit?.message
                  }
                  {...register(
                    `activitiesTransports.${index}.arrival_forecast_last_unit`,
                  )}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ))}

      {fields.length === 0 && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: 'center', py: 4 }}
        >
          Nenhum transporte cadastrado. Clique em Adicionar Transporte para
          começar.
        </Typography>
      )}
    </Box>
  )
}
